export default __webpack_public_path__ + "images/homo-sapiens-sapiens-plus.svg";